import { useAppSelector } from 'shared';

export const useDeliveryArticlePageState = () => (
    useAppSelector((store) => store.deliveryArticlePage)
);
